import * as React from 'react';
import { Heading1, Heading4 } from '../ap/base/text';
import { MaxWidthReef, MaxWidthIsland } from '../ap/pages/sections';
import { Page } from './base/page';
import { OutageIcon } from '../icons/appIcons';
import * as gls from '../ap/layout/gls';
import { trackErrorPage } from '../ap/omniture/omnitureService';

export class OutagePage extends React.Component<{}, {}> {
  componentDidMount() {
    trackErrorPage('Down for maintenance');
  }
  render() {
    return (
      <Page
        loggedIn={false}
        sections={[
          <MaxWidthReef>
            <gls.ContentVerticalCentered>
              <Heading1 id="outage-heading" text="Down for maintenance." />
            </gls.ContentVerticalCentered>
          </MaxWidthReef>,
          <MaxWidthIsland>
            <gls.ContentVerticalCentered>
              <OutageIcon />
              <gls.SmallVerticalSpace space={24} />
              <Heading4 text="The site is currently unavailable. Please try again later." />
            </gls.ContentVerticalCentered>
          </MaxWidthIsland>
        ]} />
    );
  }
}
